import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { MsgPluginFilterService } from '../services/msg-plugin-filter.service';

@Directive({
  selector: '[msgTypes]'
})
/**
 * 指令控制页面元素显隐
 */
export class MsgTypesDirective implements OnInit  {
  // 需要显示的消息类型
  @Input() msgs: any = [];

  constructor(private el: ElementRef, private msgPluginFilterService: MsgPluginFilterService) { 

  }

  /**
   * {eles:[] , ability: ''} eles支持的类型  ability权限
   */
  ngOnInit() {
    // const msgList = JSON.parse(sessionStorage.getItem('msgJars'));
    // if(this.msgs instanceof Array) {        
    //     let show = msgList.some(item => {
    //         return this.msgs.some(msg => msg.type === item.index);
    //     })
    //     if(!show) this.el.nativeElement.remove();
    // }else if(this.msgs instanceof Object) {
        
    // }

    let ability = null;
    let msgs = [];
    if(this.msgs instanceof Object) {
        ability = this.msgs.ability;
        msgs = this.msgs.eles;
    }else if(this.msgs instanceof Array) {
        msgs = this.msgs;
    }    

    this.msgPluginFilterService.msgTypeFilter(msgTypes => {
        let show = msgTypes.some(item => {
            return this.msgs.some(msg => msg.type === item.type);
        })
        if(!show) this.el.nativeElement.remove();
    }, ability);
  }
}